<div class="container-wrap" *ngFor="let p of products">
  <app-info-oc-or-nfe label="Nome" [value]="p.name"></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Código do Item" [value]="p.sku"></app-info-oc-or-nfe>
  <img *ngIf="p.productImageUrl && !isLoading" [src]="p.productImageUrl">
  <img *ngIf="!p.productImageUrl" src="/assets/icons/no-image-icon.svg">
</div>
